"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.number.constructor");
var _customerCoupon = require("@/api/activity/customerCoupon");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'customerCouponStoreNum',
  emits: ['couponSendLog'],
  props: {
    refresh: {
      type: Number,
      default: 0
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler() {
        this.getStoreNumList();
      }
    }
  },
  data: function data() {
    return {
      couponSendLogVisible: false,
      // 搜索表单
      issuePeriodType: 'month',
      searchForm: {
        storeCode: '',
        effectiveStatus: '',
        issuePeriod: '',
        sendQuarter: '',
        startTime: '',
        endTime: '',
        storeName: '',
        ruleName: '',
        regionId: '',
        page: 1,
        limit: 10,
        total: 0
      },
      couponInfoLogFrom: {
        storeId: null,
        page: 1,
        limit: 10,
        total: 0
      },
      // 日期范围
      dateRange: [],
      // 数据列表
      storeNumList: [],
      couponSendLogList: [],
      loading: false,
      loadingLog: false,
      // 城市列表
      cityList: [],
      selectedCity: '',
      quarterOptions: [{
        label: '一季度',
        value: 1
      }, {
        label: '二季度',
        value: 2
      }, {
        label: '三季度',
        value: 3
      }, {
        label: '四季度',
        value: 4
      }]
    };
  },
  created: function created() {
    this.getStoreRegionList();
    this.getStoreNumList();
  },
  methods: {
    // 券发放记录
    handleCouponSendLog: function handleCouponSendLog(row) {
      this.$emit('couponSendLog', row);
    },
    // 券发放详情
    handleCouponSendLogInfo: function handleCouponSendLogInfo(row) {
      this.getCouponSendInfo(row);
      this.couponSendLogVisible = true;
    },
    getCouponSendInfo: function getCouponSendInfo(row) {
      var _this = this;
      this.loadingLog = true;
      if (row != null) {
        this.couponInfoLogFrom.storeId = row.storeId;
      }
      (0, _customerCoupon.getCouponSendInfo)(this.couponInfoLogFrom).then(function (res) {
        if (res.code == 200) {
          _this.couponSendLogList = res.records || [];
          _this.couponInfoLogFrom.total = res.total || 0;
        } else {
          _this.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this.loadingLog = false;
      });
    },
    // 获取数据列表
    getStoreNumList: function getStoreNumList() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread({}, this.searchForm);
      if (this.issuePeriodType == 'quarter') {
        params.issuePeriod = '';
        params.sendQuarter = this.searchForm.sendQuarter;
      } else {
        params.issuePeriod = this.searchForm.issuePeriod;
        params.sendQuarter = '';
      }
      (0, _customerCoupon.getCouponStoreNum)(params).then(function (res) {
        if (res.code === 200) {
          _this2.storeNumList = res.records || [];
          _this2.searchForm.total = res.total || 0;
        } else {
          _this2.$message.error(res.msg || '查询失败');
        }
      }).finally(function () {
        _this2.loading = false;
      });
    },
    // 搜索
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getStoreNumList();
    },
    // 重置
    handleReset: function handleReset() {
      this.issuePeriodType = 'month';
      this.searchForm = {
        ruleId: '',
        storeId: '',
        storeCode: '',
        effectiveStatus: '',
        issuePeriod: '',
        sendQuarter: '',
        startTime: '',
        endTime: '',
        regionId: '',
        page: 1,
        limit: 10,
        total: 0
      };
      this.dateRange = [];
      this.getStoreNumList();
    },
    // 分页
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getStoreNumList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getStoreNumList();
    },
    handleLogSizeChange: function handleLogSizeChange(val) {
      this.couponInfoLogFrom.limit = val;
      this.getCouponSendInfo();
    },
    handleLogCurrentChange: function handleLogCurrentChange(val) {
      this.couponInfoLogFrom.page = val;
      this.getCouponSendInfo();
    },
    // 处理日期范围变化
    handleDateChange: function handleDateChange(val) {
      if (val && val.length === 2) {
        this.searchForm.startTime = val[0];
        this.searchForm.endTime = val[1];
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
    // 获取城市列表
    getStoreRegionList: function getStoreRegionList() {
      var _this3 = this;
      (0, _customerCoupon.getStoreRegionList)().then(function (res) {
        if (res.code === 200) {
          _this3.cityList = res.data || [];
        } else {
          _this3.$message.error(res.msg || '获取城市列表失败');
        }
      });
    },
    // 获取生效状态类型
    getEffectiveStatusType: function getEffectiveStatusType(status) {
      switch (status) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        default:
          return '';
      }
    },
    // 获取生效状态文本
    getEffectiveStatusText: function getEffectiveStatusText(status) {
      switch (status) {
        case 1:
          return '生效中';
        case 2:
          return '未生效';
        case 3:
          return '已失效';
        default:
          return '';
      }
    },
    // 格式化日期
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};